import AuthService from 'top20common/distribution/services/auth';
import cookies from 'top20common/distribution/services/cookies';
import LanguagesService from 'top20common/distribution/services/languages';
import manageService from 'top20common/distribution/services/manage';

export default {
  clientRegisterAction(context, {registerForm, vue}) {
    registerForm.password2 = registerForm.password1;
    context.commit('mutateRegisterFormLoading', true);
    return new Promise((resolve, reject) => {
      AuthService.registerAsClient(registerForm)
        .then(response => {
          context.dispatch('postRegisterAction', {response}).then(() => {
            resolve(response);
          });
        })
        .catch(e => {
          context.commit('mutateRegisterFormLoading', false);
          context.commit('mutateRegisterFormError', {statusCode: e.response.status, ...e.response.data.errors});
          reject(e);
        });
    });
  },
  candidateRegisterAction(context, {registerForm, vue}) {
    context.commit('mutateRegisterFormLoading', true);
    return new Promise((resolve, reject) => {
      AuthService.registerAsCandidate(registerForm)
        .then(response => {
          context.dispatch('postRegisterAction', {response}).then(() => {
            let resumeState = context.getters.resumeState;
            if (resumeState.info && (resumeState.file || resumeState.info.pre_application_id) && resumeState.info.uid) {
              context
                .dispatch('uploadCandidateResumeAction', {
                  file: resumeState.file,
                  uid: resumeState.info.uid,
                  pre_application_id: resumeState.info.pre_application_id,
                  parse: true
                })
                .then(() => {
                  resolve(response);
                })
                .finally(() => {
                  context.commit('mutateRegisterFormLoading', false);
                });
            } else {
              context.commit('mutateRegisterFormLoading', false);
              resolve(response);
            }
          });
        })
        .catch(e => {
          context.commit('mutateRegisterFormLoading', false);
          context.commit('mutateRegisterFormError', e.response.data.errors);
          reject(e);
        });
    });
  },
  postRegisterAction(context, {response}) {
    return new Promise((resolve, reject) => {
      AuthService.preLoginCleanup();

      context.commit('loginSuccess', response.data.user);
      context.commit('mutateRegisterFormLoading', false);
      cookies.set('user', response.data.user.pk);
      context.commit('mutateUserTokenState', response.data.token);
      AuthService.updateLocalStorage(response.data);

      const language = LanguagesService.getLanguageParam(localStorage.getItem('language'));
      context.dispatch('changeUserPreferencesAction', {value: {language}}).then(() => {
        resolve(response);
      });
    });
  },
  sendVerificationCodeAction(context, data) {
    return new Promise((resolve, reject) => {
      manageService
        .sendVerificationCode(data)
        .then(response => {
          context.commit('clearRegisterFormError');
          resolve(response);
        })
        .catch(e => {
          context.commit('mutateRegisterFormError', e.response.data.errors);
          reject(e);
        });
    });
  }
};
